"use strict";
var Team = (function () {
    function Team(id, name, isPlaceholder, club) {
        this.id = id;
        this.name = name;
        this.isPlaceholder = isPlaceholder;
        this.club = club;
        this.corePlayers = [];
        this.fillinPlayers = [];
        this.playerLookup = {}; // id to player
    }
    Team.prototype.addPlayer = function (p) {
        // is already added.
        if (this.playerLookup["" + p.id] !== undefined)
            return;
        // add the player.
        this.playerLookup["" + p.id] = p;
        if (p.isCore)
            this.corePlayers.push(p);
        else
            this.fillinPlayers.push(p);
    };
    return Team;
}());
exports.Team = Team;



/*****************
 ** WEBPACK FOOTER
 ** ./src/team.ts
 ** module id = 59
 ** module chunks = 1
 **/